// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","loader":"Loader_loader__DwtSp","pageLoader":"Loader_pageLoader__d-gAV"};